// components/ai/ahamoment/SuggestedTopicsBox.jsx
import React from 'react';
import { FaThumbtack } from 'react-icons/fa';

const SuggestedTopicsBox = ({ topics }) => {
  return (
    <div style={{
      backgroundColor: '#2C2F36',
      color: '#FFFFFF',
      borderRadius: '16px',
      padding: '1rem',
      marginBottom: '1rem',
      fontFamily: 'Nunito Sans',
      boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    }}>
      <div style={{
        fontWeight: '700',
        marginBottom: '0.75rem',
        fontSize: '17px',
        color: '#FF7C24',
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
      }}>
        <FaThumbtack /> Suggested Next Topics
      </div>
      <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
        {topics.map((topic, index) => (
          <li key={index} style={{ fontSize: '16px', marginBottom: '0.5rem' }}>
            {topic}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SuggestedTopicsBox;
